import React, { useEffect, useState } from 'react'

import {
  Card,
  CardContent,
  Typography,
  Container,
  TextField,
  Link,
  Grid,
  CircularProgress,
} from '@mui/material'

export default function OpenSourceLicenses() {
  const [data, setData] = useState({})
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/oss-licenses.json')
      .then((res) => res.json())
      .then((json) => {
        setData(json)
        setLoading(false)
      })
      .catch((err) => {
        console.error('Failed to load license data:', err)
        setLoading(false)
      })
  }, [])

  const entries = Object.entries(data)
    .filter(([pkg]) => pkg.toLowerCase().includes(search.toLowerCase()))
    .sort()

  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom>
        Open Source Licenses
      </Typography>

      <TextField
        fullWidth
        label="Search by package name"
        variant="outlined"
        margin="normal"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? (
        <CircularProgress />
      ) : (
        <Grid container spacing={2}>
          {entries.map(([pkg, info]) => (
            <Grid item xs={12} key={pkg}>
              <Card variant="outlined">
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {pkg}
                  </Typography>
                  <Typography variant="body2">
                    <strong>License:</strong> {info.licenses}
                  </Typography>
                  {info.repository && (
                    <Typography variant="body2">
                      <strong>Repository: </strong>
                      <Link href={info.repository} target="_blank" rel="noopener">
                        {info.repository}
                      </Link>
                    </Typography>
                  )}
                  {info.publisher && (
                    <Typography variant="body2">
                      <strong>Publisher:</strong> {info.publisher}
                    </Typography>
                  )}
                  {info.url && (
                    <Typography variant="body2">
                      <strong>Publisher URL: </strong>
                      <Link href={info.url} target="_blank" rel="noopener">
                        {info.url}
                      </Link>
                    </Typography>
                  )}
                  {info.licenseText && (
                    <Typography variant="body2">
                      <strong>License Text : </strong>
                      <Link href={info.licenseText} target="_blank" rel="noopener">
                        {info.licenseText}
                      </Link>
                    </Typography>
                  )}
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
    </Container>
  )
}
